import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';
import { createTheme as createDSTheme } from 'app/shopify';

const theme = createDSTheme();

type SectionKey = 'today' | 'thisWeek' | 'earlier';

export function SectionHeader({ sectionKey }: { sectionKey: SectionKey }) {
  const { t } = useTranslation('notifications');
  const labels: Record<SectionKey, string> = {
    today: t('sections.today', { defaultValue: "Aujourd'hui" }),
    thisWeek: t('sections.thisWeek', { defaultValue: 'Cette semaine' }),
    earlier: t('sections.earlier', { defaultValue: 'Plus ancien' }),
  };
  return (
    <Text
      fontSize={13}
      fontWeight="600"
      color="text.secondary"
      style={{
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        paddingHorizontal: theme.spacing['spacing.general.x4'],
        paddingTop: theme.spacing['spacing.general.x5'],
        paddingBottom: theme.spacing['spacing.general.x1'],
      }}
    >
      {labels[sectionKey]}
    </Text>
  );
}
